import {IV_DOCUMENT_IMAGE_TYPES} from '@chekin/core';

const getHelperTextKey = (type?: IV_DOCUMENT_IMAGE_TYPES, hasTwoSides?: boolean) => {
  switch (type) {
    case IV_DOCUMENT_IMAGE_TYPES.front:
      return hasTwoSides
        ? 'choose_upload_type_front_side_text'
        : 'choose_upload_type_data_page_text';
    case IV_DOCUMENT_IMAGE_TYPES.back:
      return 'choose_upload_type_back_side_text';
    default:
      return null;
  }
};

export {getHelperTextKey};
